import React from 'react';
export const WixStyleReactEnvironmentContext = React.createContext({});
//# sourceMappingURL=context.js.map